import { computed } from 'vue';
import { useCommonProductGetters } from '@composables/useCommonProductGetters';
import { useBrand } from './useBrand';

// TODO check if we need to pass product/id here for members of master
function shopSimilarItemsUrlMCOM() {
  const { taxonomy } = useCommonProductGetters();

  const categories = computed(() => taxonomy.value.categories || []);
  const defaultCategoryId = computed(() => taxonomy.value.defaultCategoryId);

  const defaultCategory = categories.value.find((category) => category.id === defaultCategoryId.value);

  return defaultCategory?.url || '';
}

function shopSimilarItemsUrlBCOM() {
  const { topLevelCategoryName, typeName } = useCommonProductGetters();
  const urlRoot = '/shop/search';
  const type = typeName.value.replace(/[^a-zA-Z0-9_\s-]/g, '').replace(/\s+|_/g, '+');

  if (!topLevelCategoryName || !type) {
    return '';
  }

  const searchParamValue = encodeURIComponent(`${topLevelCategoryName} ${type}`.toLowerCase());

  return `${urlRoot}?keyword=${searchParamValue}`;
}

export default function useUnavailableProduct() {
  const { isMcom } = useBrand();
  return {
    similarItemsUrl: isMcom ? shopSimilarItemsUrlMCOM() : shopSimilarItemsUrlBCOM(),
  };
}
